import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import moment from 'moment'
import _ from 'lodash'

import { fetchContactLogs } from '../../actions'
import { generateStatusTabs } from '../../helpers'

import Loading from '../Loading'

import { Timeline } from 'antd'

const notVisibleFields = ['reachedType', 'assigneeName']
const dateFields = ['recallDate', 'appointmentDate', 'nextCallDate']

class ContactLogs extends Component {
  componentDidMount () {
    const { match: { params }, fetchContactLogs, contactId } = this.props

    fetchContactLogs(params.projectId, contactId)
  }

  render () {
    const { t, match: { params }, contactLogs, contactId, loading, projects, companies } = this.props

    if (loading.fetchContactLogs) return <Loading />

    const currentProject = projects[params.projectId]
    const projectQuestions = currentProject.questions
    const companyUsers = companies[currentProject.companyId].users

    const statusTabs = generateStatusTabs(currentProject.possibleCalls)

    return (
      <div>
        {contactLogs && contactLogs[contactId] && _.size(contactLogs[contactId])
          ? <Timeline>
            {_.map(_.orderBy(contactLogs[contactId], 'createdAt', 'asc'), (log, index) => (
              <Timeline.Item key={index}>

                <div style={{ fontSize: 10, color: '#ccc', marginRight: 10 }}>
                  {moment(log.createdAt).format('MMMM Do YYYY, HH:mm')}
                  <b> {log.createdBy && log.createdBy.name_sync}</b>
                </div>

                <h3>{t(`contact.status.${statusTabs[log.status]}`)}</h3>
                <table>
                  <tbody>
                    {log.data &&
                        _.map(
                          log.data,
                          // 'key' = input name, 'value' = input value
                          (value, key) =>
                            value !== null &&
                            !notVisibleFields.includes(key) &&
                            <tr key={key} style={{ padding: key === 'questions' ? '10px 0' : 0 }}>
                              <td style={{ width: 120, verticalAlign: 'top' }}>
                                <b>{t(`contactLog.${key}`)}</b>
                              </td>
                              <td style={{ verticalAlign: 'top' }}>
                                {key === 'questions' // go through all answers and render them
                                  ? _.map(
                                      value,
                                      (answer, questionId) =>
                                        answer &&
                                        <div style={{ padding: '5px 0' }} key={questionId}>
                                          <div style={{ fontWeight: 'bold' }}>
                                            •{' '}
                                            {/* if someone deletes some question after we already did some calls, use question.id instead of question.text */}
                                            {projectQuestions[questionId]
                                              ? projectQuestions[questionId].text
                                              : questionId}
                                          </div>
                                          <div>{answer}</div>
                                        </div>
                                    )
                                  : dateFields.includes(key)
                                      ? moment(parseInt(value, 10)).format('MMMM Do YYYY, HH:mm')
                                      : key === 'assignee'
                                          ? value === 'generic'
                                              ? log.data.assigneeName
                                              : companyUsers[log.data.assignee].name_sync
                                          : typeof value === 'boolean' ? value === true ? 'true' : 'false' : value}
                              </td>
                            </tr>
                        )}
                  </tbody>
                </table>

              </Timeline.Item>
              ))}
          </Timeline>
          : 'there are currently no logs for this contact'}
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  contactLogs: state.contactLogs,
  projects: state.projects,
  companies: state.companies
})

const mapDispatchToProps = {
  fetchContactLogs
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(translate('translations')(ContactLogs)))



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactLogs.js